var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "screen-control-default-cell" },
    [
      _c("kh-text", {
        directives: [
          {
            name: "kh-animation",
            rawName: "v-kh-animation",
            value: _vm.directiveAnimationRightToLeft,
            expression: "directiveAnimationRightToLeft",
          },
        ],
        attrs: { text: _vm.text },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }